interface IProps {
  children: JSX.Element
}

const InPageConfirmationModal = ({ children }: IProps) => {
  return <div>{children}</div>
}

export { InPageConfirmationModal }
